import { appendHelpers } from '../helpers/helpers_manager'
import { formatDate } from '@/utils/date_manipulation'

const moduleName = '.editorial'

export default ({
  repository,
  clientWrapper,
  context
}) => ({
  searchByDate: (date, filtersParams = {}) => {
    context.lastApiPath = `${moduleName}.searchByDate`
    const helpers = ['issue', 'status', 'revision', 'images', 'rects']

    const filters = { resourcesType: 'all', status: 'ready', page: 1, pageSize: 150, ...filtersParams}
    const formattedDate = formatDate({ date }).split('-')
    const resource_types = filters.resourcesType === 'all' ? 'magazine,newspaper,website' : filters.resourcesType
    let statuses = filters.status === 'all' ? null : filters.status
    statuses = statuses === 'readyToSend' ? 'completed' : statuses
    const apiEndpoint = `/resources/${formattedDate[0]}/${formattedDate[1]}/${formattedDate[2]}`
    return clientWrapper.api.get(apiEndpoint, {
        params: { resource_types, statuses, page: filters.page, page_size: filters.pageSize }
      })
      .then(({ data }) => data.map(pub => pub.attributes))
      .then(publications => publications.map(pub => appendHelpers(pub, repository, helpers)))
  },

  countByRange: (startDate, endDate) => {
    context.lastApiPath = `${moduleName}.countByRange`

    return clientWrapper.api.get('/resources/count.json', {
      params: {
        start_date: formatDate({ date: startDate }),
        end_date: formatDate({ date: endDate }),
        resource_types: 'magazine,newspaper,website'
      }
    })
  }
})